<template>
    <div>
        <div class="notFound"></div>
        <!-- <div>
            <el-main class="context">
                <p class="title">{{ $t('error.ERROR_PAGE_ERROR') }}</p>
                <p class="prompt">{{ $t('error.ERROR_ENTER_RETURN') }}</p>
                <div>
                    <td-button type="primary" plain @click="back">{{ $t('common.HOMEBACK') }}</td-button>
                </div>
            </el-main>
        </div> -->
    </div>
</template>
<script>
export default {
    methods: {
        back() {
            this.$router.go(-1); //返回上一层
        }
    }
};
</script>
